
import moment from 'moment';
import { AssetListSearchResponse, AssetResponse } from 'services/assets';

export function assetSearchToAsset(
  data: AssetListSearchResponse,
  listrv: any,
  nbasset: number,
  cteid: number,
  origine: string,
  listuse: any,
  flaguseassetgrossamount?: boolean,
): AssetResponse {
  if (nbasset === null) {
    nbasset = 1;
  }
  return {
    assetmodellabel: data.assetmodellabel,
    assettaggrouping: '',
    cteid: cteid,
    assetexpdeliverydate: data.assetexpdeliverydate ?? '',
    listrv: listrv,
    irvSchedule: [],
    assetusereqList: listuse,
    catalogid: data.catalogid,
    assetpictureurl: data.assetpictureurl ?? '',
    assetqty: nbasset,
    assetsegment: data.assetsegment,
    assetsegmentlabel: data.assetsegmentlabel,
    assetfamily: data.assetfamily,
    assetfamilylabel: data.assetfamilylabel,
    assetclass: data.assetclass,
    assetunitnetamount:
      origine === 'free' ? data.assetnetamount / nbasset : data.assetnetamount,
    assetComponents: data.assetComponents,
    assetcategory: data.assetcategory,
    assetcategorylabel: data.assetcategorylabel,
    assetconstructor: data.assetconstructor,
    assetdeliverydate: moment().format('YYYY-MM-DD'),
    assetdeliveryreference: '',
    assetdescription: data.assetdescription,
    assetgrossamount:
      origine === 'free'
        ? data.assetgrossamount
        : data.assetgrossamount * nbasset,
    assetid: data.assetid,
    assetlabel: data.assetlabel,
    assetmodel: data.assetmodel,
    assetmulticomponents: data.assetmulticomponents,
    assetnetamount:
      origine === 'free' ? data.assetnetamount : data.assetnetamount * nbasset,
    assetorderdate: data.assetorderdate,
    assetorderreference: data.assetorderreference ?? '',
    assetphase: data.assetphase === 'STOCKIN' ? 'REMARK' : 'INIT',
    assetreference: data.assetreference,
    assetrisklevel: data.assetrisklevel,
    assetstatus: data.assetstatus === 'STOCK' ? 'REMARK' : 'INIT',
    assetstatusdate: moment().format('YYYY-MM-DD'),
    assettaxamount: data.assettaxamount * nbasset,
    assettype: data.assettype,
    assettypelabel: data.assettypelabel,
    chassisno: data.chassisno ?? '',
    created_at: moment().format('YYYY-MM-DD'),
    created_by: 0,
    currcode: data.currcode,
    deliveryadrcity: data.deliveryadrcity,
    deliveryadrcountry: data.deliveryadrcountry,
    deliveryadrregion: data.deliveryadrregion,
    deliveryadrstreet1: data.deliveryadrstreet1,
    deliveryadrstreet2: data.deliveryadrstreet2,
    deliveryadrzipcode: data.deliveryadrzipcode,
    engineno: data.engineno,
    fiscaldepreciationmethod: data.fiscaldepreciationmethod,
    flagused: false,
    last_action: '',
    plateno: data.plateno,
    power: data.power,
    registrationno: data.registrationno,
    serialno: data.serialno,
    statuslabel: data.statuslabel,
    suppliername: data.suppliername,
    supplierreference: data?.refsupplier ?? data?.supplierreference,
    taxcode: data.taxcode,
    taxrate: data.taxrate,
    tpidsupplier: data.tpidsupplier,
    manufacturername: data.manufacturername,
    manufacturerreference: data.manufacturerreference,
    tpidmanufacturer: data.tpidmanufacturer,
    updated_at: moment().format('YYYY-MM-DD'),
    updated_by: 0,
    weight: data.weight,
    flagholdback: data.flagholdback,
    holdbackpercentage: data.holdbackpercentage,
    holdbackamount: data.holdbackamount,
    holdbackbeleasenbdays: data.holdbackbeleasenbdays,
    holdbackbeleasedate: data.holdbackbeleasedate ?? '',
    kwhdegradation: data.kwhdegradation,
    kwhpower: data.kwhpower,
    kwhproduction: data.kwhproduction,
    assetfinamount: flaguseassetgrossamount
      ? data.assetgrossamount
      : data.assetnetamount,
    brokername: '',
    brokerreference: '',
    degfeesformula: '' as any,
    networkcode: data?.networkcode,
    spfeesformula: '' as any,
    tpidbroker: 0,
    tpofformula: '' as any,
    assetServiceList: data.assetCatalogServices,
    entityAddAttributList: data?.entityAddAttributList ?? [],
    assetCatalogOptionsToPropose: [],
    assetUpgradeList: [],
    age: data.age,
    wheeldrive: data?.wheeldrive,
    balersize: data?.balersize,
    separatortype: data?.separatortype,
    transmission: data?.transmission,
    wheeltrack: data?.wheeltrack,
    lift: data?.lift,
    capacity: data?.capacity,
    tankcapacity: data?.tankcapacity,
    nbcampaign: data?.nbcampaign,
    threshinghours: data?.threshinghours,
    rotorhours: data?.rotorhours,
    totalbalers: data?.totalbalers,
    registrationcity: data?.registrationcity,
    registrationname: data?.registrationname,
    registrationdate: data?.registrationdate,
    firstregistrationdate: data?.firstregistrationdate,
    fiscalpower: data?.fiscalpower,
    country: data?.country ?? '',
  };
}
